import { getRomaToKana, initKuroshiro } from "./common";


let setGlobalLoading = () => {}; // ローディング状態を更新する関数
let notify = () => {}; // 初期の通知関数

export const setNotifyHandler = (handler) => {
  notify = handler;
};

export const setLoadingHandler = (handler) => {
  setGlobalLoading = handler; // グローバルローディング関数を設定
};

const getQueryParams = () => {
  const queryString = window.location.href.split("?")[1]; // "?" 以降の文字列を取得
  if (!queryString) return {}; // クエリがない場合は空のオブジェクトを返す

  return queryString.split("&").reduce((params, param) => {
    const [key, value] = param.split("="); // key=value の形式を分解
    params[decodeURIComponent(key)] = decodeURIComponent(value || ""); // デコード処理
    return params;
  }, {});
};


const customDataProvider = {
  // リストデータを取得
  getList: async (resource, params) => {
    try{
      const queryParams = getQueryParams();
      const customer = queryParams["customer"] || null;
      const bukken = queryParams["bukken"] || null;
      const bukken_k = queryParams["bukken_k"] || null;
      const surname = queryParams["surname"] || null;
      const phone = queryParams["phone"] || null;
      const telephone = queryParams["telephone"] || null;
      const fax = queryParams["fax"] || null;
      const address = queryParams["address"] || null;
      const orner_surname = queryParams["orner_surname"] || null;

      setGlobalLoading(true);
      const { page, perPage } = params.pagination;
      const { field, order } = params.sort;
      const query = {
        ...(customer && { customer }),
        ...(bukken && { bukken }),
        ...(bukken_k && { bukken_k }),
        ...(surname && { surname }),
        ...(phone && { phone }),
        ...(telephone && { telephone }),
        ...(fax && { fax }),
        ...(address && { address }),
        ...(orner_surname && { orner_surname }),

        _page: page,
        _limit: perPage,
        _sort: field,
        _order: order,
        ...params.filter, // フィルタリング条件
      };

      if(resource === "inspect"){
        resource = "customers/inspect/latest";
      }
      if(resource === "customers"){
        resource = "customers/search";
      }

      if (resource.includes("-clean")) {
        query.customerFlag = "isCleanCus"; // 浄化槽清掃
      } else if (resource.includes("-inspect")) {
        query.customerFlag = "isInspectCus"; // 浄化槽点検
      } else if (resource.includes("-construct")) {
        query.customerFlag = "isConstructCus"; // ごみ収集(委託)
      }else if (resource.includes("-garbage-commit")) {
        query.customerFlag = "isGarbageCommitCus"; // ごみ収集(委託)
      } else if (resource.includes("-garbage-allow")) {
        query.customerFlag = "isGarbageAllowCus"; // ごみ収集(許可)
      } else if (resource.includes("-waste")) {
        query.customerFlag= "isGarbageCommitCus"; // し尿
      }
      resource = resource.split("-")[0];

      const queryString = new URLSearchParams(query).toString();
      
      const response = await fetch(`${process.env.REACT_APP_API_DIR}/${resource}?${queryString}`, {
        method: 'GET',
        mode: 'cors',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
      });
      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }
      const {data} = await response.json();
      let idName = null;
      switch(resource){
        case "customers":
          idName = "customerId";
          break;
        case "customers/all":
          idName = "customerId";
          break;
        case "requesters":
          idName = "requesterId";
          break;
        case "uncollect":
          idName = "invoiceId";
          break;
        case "users":
          idName = "userId";
           break;
        case "cleanReceptHistory":
          idName = "receptId";
          break;
        case "cleanHistory":
          idName = "cleaningId";
          break;
        case "inspectHistory":
          idName = "inspectId";
          break;
        case "constructHistory":
          idName = "constructId";
          break;
        case "contactHistory":
          idName = "contactId";
          break;
        case "visitHistory":
          idName = "visitId";
          break;
        case "invoiceHistory":
          idName = "invoiceId";
          break;
        case "estimateHistory":
          idName = "estimateId";
          break;
        default:
          break;
      }
      const list = data.list.map((item, index) => ({
        ...item,
        ["number"]:item["id"],
        id: item[idName]
      }));
      return {
        data: list,
        total: data.total,
      };
    }catch(error){
      console.log(error);
    }finally{
      setGlobalLoading(false);
    }
  },

  // 個別データを取得
  getOne: async (resource, params) => {
    if(resource.includes("invoice-form") || resource.includes("reset-password")){
      return Promise.resolve({data:{id:params.id}});
    }
    try {
      resource = resource.split("-")[0];
      if(resource === "uncollect"){
        resource = "invoiceHistory"
      }
      setGlobalLoading(true);
      const response = await fetch(`${process.env.REACT_APP_API_DIR}/${resource}/${params.id}`, {
        headers: { "Content-Type": "application/json" },
        mode: 'cors',
        credentials: 'include',
      });
      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }
      const {data} = await response.json();
      return Promise.resolve({ data });
    } catch (error) {
      console.log(error);
    }finally{
      setGlobalLoading(false);
    }
  },

  // 複数のデータを取得
  getMany: async (resource, params) => {
    try {
      setGlobalLoading(true);
      const ids = params.ids.join(",");
      const response = await fetch(`${process.env.REACT_APP_API_DIR}/${resource}?id_in=${ids}`, {
        headers: { "Content-Type": "application/json" },
        mode: 'cors',
        credentials: 'include',
      });
      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }
      const data = await response.json();
  
      return {
        data,
      };
    } catch (error) {
      console.log(error);
    }finally{
      setGlobalLoading(false);
    }
  },

  // 新規データを作成
  create: async (resource, params) => {
    resource = resource.split("-")[0];
    try {
      setGlobalLoading(true);
      const response = await fetch(`${process.env.REACT_APP_API_DIR}/${resource}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        mode: 'cors',
        credentials: 'include',
        body: JSON.stringify(params.data),
      });
      if (!response.ok) {
        notify("エラーが発生しました", { type: "error" });
        throw new Error("Failed to create data");
      }
      const {data} = await response.json();
      if(data){
        if(data.isError){
          notify(data.message || "エラーが発生しました", { type: "error" });
          return Promise.reject(new Error(data.message || "エラーが発生しました"));
        }
        if(params.data.documentURL){
          let fileType = "";
          let id = null;
          if(resource === "customers"){
            fileType = "contract";
            id = data.customerId
          }
          else if(resource === "estimateHistory"){
            fileType = "estimate";
            id = data.estimateId;
          }
          else{
            fileType = "invoice";
            id = data.invoiceId;
          }
          await uploadFile(id,fileType,params.data.documentURL.rawFile);
        }
        if(params.data.pictureURL){
          await uploadPicture(data.id,"construct",params.data.pictureURL.rawFile);
        }
        notify("登録が完了しました", { type: "success" });
        return Promise.resolve({ data });
      }
      else{
        notify("エラーが発生しました", { type: "error" });
      }
 
    } catch (error) {
      console.log(error)
    } finally{
      setGlobalLoading(false);
    }
  },

  // データを更新
  update: async (resource, params) => {
    resource = resource.split("-")[0];
    if(resource === "uncollect"){
      resource = "invoiceHistory"
    }
    try {
      setGlobalLoading(true);
      const response = await fetch(`${process.env.REACT_APP_API_DIR}/${resource}/${params.id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        mode: 'cors',
        credentials: 'include',
        body: JSON.stringify(params.data),
      });
      if (!response.ok) {
        notify("エラーが発生しました", { type: "error" });
        throw new Error("Failed to create data");
      }
      const {data} = await response.json();
      if(data){
        if(data.isError){
          notify(data.message || "エラーが発生しました", { type: "error" });
          return Promise.reject(new Error(data.message || "エラーが発生しました"));
        }
        console.log(params.data);
        if(params.data.documentURL){
          let fileType = "";
          let id = null;
          if(resource === "customers"){
            fileType = "contract";
            id = data.customerId
          }
          else if(resource === "estimateHistory"){
            fileType = "estimate";
            id = data.estimateId;
          }
          else{
            fileType = "invoice";
            id = data.invoiceId;
          }
          await uploadFile(id,fileType,params.data.documentURL.rawFile)
        }
        if(params.data.pictureURL){
          await uploadPicture(data.id,"construct",params.data.pictureURL.rawFile);
        }
        notify("更新が完了しました", { type: "success" });
        return Promise.resolve({ data });
      }
      else{
        notify("エラーが発生しました", { type: "error" });
      }
    } catch (error) {
      console.log(error);
    }finally{
      setGlobalLoading(false);
    }

  },

  // データを削除
  delete: async (resource, params) => {
    try {
      setGlobalLoading(true);
      resource = resource.split("-")[0];
      const response = await fetch(`${process.env.REACT_APP_API_DIR}/${resource}/${params.id}`, {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
        mode: 'cors',
        credentials: 'include',
      });
      if (!response.ok) {
        notify("エラーが発生しました", { type: "error" });
        throw new Error("Failed to create data");
      }
      const {data} = await response.json();
      console.log(data);
      if(data){
        notify("削除が完了しました", { type: "success" });
        return Promise.resolve({ data });
      }
      else{
        notify("エラーが発生しました", { type: "error" });
      }
    } catch (error) {
      console.log(error);
    }finally{
      setGlobalLoading(false);
    }

  },

  // その他のメソッド（必要に応じて実装）
  getManyReference: async () => Promise.reject("Not implemented"),
  updateMany: async () => Promise.reject("Not implemented"),
  deleteMany: async () => Promise.reject("Not implemented"),
};

const uploadFile = async(id,fileType,documentURL) =>{
  const formData = new FormData();
  console.log(documentURL)
  formData.append("id",id);
  formData.append("fileType", fileType);
  formData.append("fileName",documentURL.name);
  formData.append("documentURL", documentURL);

  const response = await fetch(`${process.env.REACT_APP_API_DIR}/documents`, {
    method: "POST",
    mode: 'cors',
    credentials: 'include',
    body: formData,
  });
  if (!response.ok) {
    notify("エラーが発生しました", { type: "error" });
    throw new Error("Failed to create data");
  }
  const result = await response.json();
  if(!result){
    notify("エラーが発生しました", { type: "error" });
  }
}

const uploadPicture = async(id,fileType,pictureURL) =>{
  const formData = new FormData();
  console.log(pictureURL)
  formData.append("id",id);
  formData.append("fileType", fileType);
  formData.append("fileName",pictureURL.name);
  formData.append("pictureURL", pictureURL);

  const response = await fetch(`${process.env.REACT_APP_API_DIR}/pictures`, {
    method: "POST",
    mode: 'cors',
    credentials: 'include',
    body: formData,
  });
  if (!response.ok) {
    notify("エラーが発生しました", { type: "error" });
    throw new Error("Failed to create data");
  }
  const result = await response.json();
  if(!result){
    notify("エラーが発生しました", { type: "error" });
  }
}

export default customDataProvider;
